import { SYSTEM_CONFIG } from "@hooks/contexts/config";
import { IRaffleType } from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import { isNumeric } from "../General";
import { Masks } from "../Masks/Masks";

interface IRaffleIsValidTicketPriceDTO {
  price: number;
  min?: number;
  max?: number;
  type?: IRaffleType;
}

interface IRaffleIsValidTicketQuantityDTO {
  quantity: number;
  min?: number;
  max?: number;
  type?: IRaffleType;
}

interface IRaffleIsValidRewardPriceDTO {
  price: number;
  min: number;
  max: number;
}

const masks = new Masks();
export const RaffleCreateIsValidTicketPrice = ({
  price = 0,
  min,
  max,
  type,
}: IRaffleIsValidTicketPriceDTO): string | undefined => {
  if (!isNumeric(price)) return `O preço informado não é válido.`;
  if (!type) return `Houve um erro ao identificar o tipo de Campanha.`;

  // --- Prepare Info to Execute the Function --- //
  switch (type) {
    case "default_number":
      min = min || SYSTEM_CONFIG.raffle.raffleNumber.ticket.price.min || 0;
      max = max || SYSTEM_CONFIG.raffle.raffleNumber.ticket.price.max || 0;
      break;

    case "default_word":
      min = min || SYSTEM_CONFIG.raffle.raffleWord.ticket.price.min || 0;
      max = max || SYSTEM_CONFIG.raffle.raffleWord.ticket.price.max || 0;
      break;

    default:
      return "Houve um erro ao definir os valores permitidos.";
  }

  // --- Lower than Min Quantity Allowed --- //
  const errorMessage =
    price < min
      ? `O preço mínimo permitido é de ${masks.brlCurrency(min)}.`
      : // --- Higher than Max Quantity Allowed --- //
      price > max
      ? `O preço máximo permitido é de ${masks.brlCurrency(max)}.`
      : undefined;

  return errorMessage;
};

export const RaffleCreateIsValidTicketQuantity = ({
  quantity = 0,
  min,
  max,
  type,
}: IRaffleIsValidTicketQuantityDTO): string | undefined => {
  if (!isNumeric(quantity)) return `O preço informado não é válido.`;
  if (!type) return `Houve um erro ao identificar o tipo de Campanha.`;

  // --- Prepare Info to Execute the Function --- //
  switch (type) {
    case "default_number":
      min = min || SYSTEM_CONFIG.raffle.raffleNumber.ticket.quantity.min || 0;
      max = max || SYSTEM_CONFIG.raffle.raffleNumber.ticket.quantity.max || 0;
      break;

    case "default_word":
      min = min || SYSTEM_CONFIG.raffle.raffleWord.ticket.quantity.min || 0;
      max = max || SYSTEM_CONFIG.raffle.raffleWord.ticket.quantity.max || 0;
      break;

    default:
      return "Houve um erro ao definir os valores permitidos.";
  }

  // --- Lower than Min Quantity Allowed --- //
  const errorMessage =
    quantity < min
      ? `A quantidade mínima permitida é de ${masks.formatMilhar(min)}.`
      : // --- Higher than Max Quantity Allowed --- //
      quantity > max
      ? `A quantidade máxima permitida é de ${masks.formatMilhar(max)}.`
      : undefined;

  return errorMessage;
};

export const RaffleCreateIsValidRewardPrice = ({
  price = 0,
  min,
  max,
}: IRaffleIsValidRewardPriceDTO): string | undefined => {
  if (!isNumeric(price)) return `O preço informado não é válido.`;

  // --- Lower than Min Quantity Allowed --- //
  const errorMessage =
    price < min
      ? `O preço mínimo permitido é de ${masks.brlCurrency(min)}.`
      : // --- Higher than Max Quantity Allowed --- //
      price > max
      ? `O preço máximo permitido é de ${masks.brlCurrency(max)}.`
      : undefined;

  return errorMessage;
};
